import { apiClient } from '../client'
import type {
  DeviceAsset,
  CreateDeviceAssetRequest,
  CreateDeviceFromWorkOrderRequest,
  DeviceAssetPageParams,
  DeviceAssetPageResponse,
} from '../types/asset'

export async function getDeviceAssets(): Promise<DeviceAsset[]> {
  const result = await getDeviceAssetPage({ page: 0, size: 200 })
  return result.content
}

export async function getDeviceAssetPage(
  params: DeviceAssetPageParams = {}
): Promise<DeviceAssetPageResponse> {
  const search = new URLSearchParams()
  search.set('page', String(params.page ?? 0))
  search.set('size', String(params.size ?? 20))
  if (params.keyword) search.set('keyword', params.keyword)
  return apiClient.get<DeviceAssetPageResponse>(`/api/device-assets?${search.toString()}`)
}

export async function getDeviceAsset(id: number): Promise<DeviceAsset> {
  return apiClient.get<DeviceAsset>(`/api/device-assets/${id}`)
}

export async function createDeviceAsset(
  data: CreateDeviceAssetRequest
): Promise<DeviceAsset> {
  return apiClient.post<DeviceAsset>('/api/device-assets', data)
}

export async function createDeviceFromWorkOrder(
  workOrderId: number,
  data: CreateDeviceFromWorkOrderRequest
): Promise<DeviceAsset> {
  return apiClient.post<DeviceAsset>(`/api/device-assets/from-work-order/${workOrderId}`, data)
}

export async function bindDeviceToWorkOrder(
  workOrderId: number,
  deviceAssetId: number
): Promise<void> {
  return apiClient.post<void>(`/api/work-orders/${workOrderId}/bind-device-asset`, {
    deviceAssetId,
  })
}
